module.exports = __webpack_public_path__ + "static/media/business-philosophy-banner1.ff69d9d1.png";